export default __webpack_public_path__ + "static/media/i_bus-jeonse_rd_tagless.4fd8e5b9.svg";